import React from "react";
import { Navigate, Outlet, useLocation  } from "react-router-dom";
import {getToken} from '../Common'

const UnauthenticatedUsersNotAllowed = () => {
    const { pathname, search } = useLocation()
    return getToken() ?  <Outlet /> : <Navigate to={`/login?redirect=${pathname}${search}`} />
}

export default UnauthenticatedUsersNotAllowed;